// 9fbef606107a605d69c0edbcd8029e5d
import Styled, { css } from 'styled-components';

export const buttonPrev = css`
  cursor: pointer;
  display: block;
  position: absolute;
  z-index: 1;
  transform: translateY(-50%);
  overflow: hidden;
  left: 0px;
  background: transparent;
  border: 0;
  padding-left: 0;

  &::before {
    content: '';
    transform: rotate(-45deg);
    display: inline-block;
    position: relative;
    border-radius: 2px;
    left: 0px;
  }
`;

export const buttonNext = css`
  cursor: pointer;
  display: block;
  position: absolute;
  z-index: 1;
  transform: translateY(-50%);
  overflow: hidden;
  right: 0px;
  background: transparent;
  border: 0;
  padding-right: 0;

  ::before {
    content: '';
    display: inline-block;
    position: relative;
    border-radius: 2px;
    transform: rotate(135deg);
    right: 0px;
  }
`;

export const arrowWrapper = css`
  display: flex;
  position: absolute;
  align-items: center;
  height: 15px;
  width: 19px;
  top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};

  @media ${(props) => props.theme.mediaQuery.large} {
    height: 20px;
    top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }
`;
export const snjPrimary = css`
  color: ${(props) => props.theme.colorPalette.black};
  font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
  text-align: center;
  border: none;
  background-size: 400% 50%;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  background-image: linear-gradient(
    147deg,
    #c1b3fe,
    #c1b3fe,
    #c1b3fe,
    #dfb3fe,
    #ffb3df,
    #ffb2c0,
    #ffd9b4
  );
  &:hover {
    background-position: 100% 0;
    -moz-transition: all 0.4s ease-in-out;
    -o-transition: all 0.4s ease-in-out;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    background-size: 170%;
  }

  &:focus {
    outline: none;
  }
`;
export const imageAnchorInheritedStyles = css`
  display: block;
`;

export const ProductMerchantPrice = Styled.div`
  display: flex;

  ${(props) => {
    if (props.isTileRedesignAB && !props.isFavoriteView) {
      return `
      gap: 4px;
      @media ${props.theme.mediaQuery.smallOnly} {
        gap: 2px;
      }
      `;
    }
    return 'gap: 10px;';
  }}
`;
